import React from "react";

// Customizable Area Start
import {
  View,
  Button,
  StyleSheet,
  Platform,
  ScrollView,
  Text,
  ImageBackground,
  ActivityIndicator,
  TextInput,
  Image,
  KeyboardAvoidingView,
  TouchableOpacity
} from "react-native";
import { Formik } from "formik";

import * as yup from "yup";


// Customizable Area End

import ForgotPasswordController, { Props } from "./ForgotPasswordController";

export default class NewPassword extends ForgotPasswordController {
  // Customizable Area Start
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.isChangePassword = true;
    // Customizable Area Start
    // Customizable Area End
  }

  render() {
    console.log(this.state.validationSchema)
    return (
                  window.screen.width < 950 ? 
            <View style={styles.container}>
          
          <View style={styles.card}>
              <img src={require("../assets/illustration-register-copy@3x.png")} style={{
            width: 216,
            height: 234,
            position: 'absolute',
            top: -165,
            left: 180,
            zIndex: 99
            }}/>
          {/* ------------------- HEADER ---------------------- */}
          {/* Customizable Area Start */}
          <View>
            <View style={styles.headline}>
              <Text style={styles.upperText}>
                {this.labelTextIsPleaseEnterYourNewPassword}
              </Text>
              {/* Confirmation status  */}
              {this.state.accountStatus === "Confirmation" ? (
                <Text style={styles.stepText}>
                  {this.labelTextIsYourPasswordHasBeenSuccessfullyChanged}
                </Text>
              ) : null}
            </View>
          </View>
          {/* -------------------- BODY ----------------------- */}
          <View>
            {/* {this.state.accountStatus === "ChangePassword" ? ( */}
              <Formik
                initialValues={{ password: "", rePassword: "" }}
                validationSchema={this.validationSchemas}
                onSubmit={(values, actions) => {
                  this.goToConfirmationAfterPasswordChange(values);
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  handleBlur,
                  touched
                }) => (
                  <View>
                    <View
                      style={
                        Platform.OS === "web"
                          ? styles.passwordContainerWeb
                          : styles.bgPasswordContainer
                      }
                    >

{/*-------------------------- Password Field--------------------------------------------------- */}
                      <TextInput
                        testID={"txtInputPassword"}
                        style={
                          Platform.OS === "web"
                            ? styles.passwordInputWeb
                            : styles.bgPasswordInput
                        }
                        placeholder={this.placeholderIsPassword}
                        placeholderTextColor="#b2bac6"
                        onChangeText={handleChange("password")}
                        onBlur={() => handleBlur("password")}
                        secureTextEntry={
                          this.state.enablePasswordField ? true : false
                        }
                      />
                    </View>
                    <View>
                      {touched.password && errors.password ? (
                        <Text style={styles.errorStyle}>{errors.password}</Text>
                      ) : null}
                      <Text
                        style={
                          Platform.OS === "web" ? styles.passwordRulesStyle : {}
                        }
                      >
                        {this.state.passwordRules}
                      </Text>
                    </View>
                    
  {/* -------------------------------------Retype-Password field---------------------------------------------------- */}
                    
                    <View
                      style={
                        Platform.OS === "web"
                          ? styles.passwordContainerWeb
                          : styles.bgPasswordContainer
                      }
                    >
                      <TextInput
                        testID={"txtInputConfirmPassword"}
                        style={
                          Platform.OS === "web"
                            ? styles.passwordInputWeb
                            : styles.bgPasswordInput
                        }
                        placeholder={this.placeholderIsReTypePassword}
                        placeholderTextColor="#b2bac6"
                        onChangeText={handleChange("rePassword")}
                        onBlur={() => handleBlur("rePassword")}
                        secureTextEntry={
                          this.state.btnConfirmPasswordShowHide ? true : false
                        }
                      />
                    </View>
                    <View>
                      {touched.rePassword && errors.rePassword ? (
                        <Text style={styles.errorStyle}>
                          {errors.rePassword}
                        </Text>
                      ) : null}
                    </View>
                  
                    <TouchableOpacity disabled={this.state.loader}  onPress={() => handleSubmit()}>
              <View style={this.state.loader ? styles.unactive_button : styles.button}>
          <Text style={styles.buttonText}>Continue</Text>
          {this.state.loader ? <ActivityIndicator style={{position: 'absolute', right: 160}} size="large" color="#2e2442" /> : null }
      </View>
    </TouchableOpacity>
                  </View>
                )}
              </Formik>
            {/* ) : null} */}
        
          </View>
              {/* Customizable Area End */}
              </View>
        </View>
        :
          <View style={styles.desktopContainer}>
           <ImageBackground source={require('../assets/group.png')} resizeMode="cover" style={styles.image}>
            <View style={styles.desktopCard}>
                           <View style={styles.card}>
          {/* ------------------- HEADER ---------------------- */}
          {/* Customizable Area Start */}
          <View>
            <View style={styles.headline}>
              <Text style={styles.upperText}>
                {this.labelTextIsPleaseEnterYourNewPassword}
              </Text>
              {/* Confirmation status  */}
              {this.state.accountStatus === "Confirmation" ? (
                <Text style={styles.stepText}>
                  {this.labelTextIsYourPasswordHasBeenSuccessfullyChanged}
                </Text>
              ) : null}
            </View>
          </View>
          {/* -------------------- BODY ----------------------- */}
          <View>
            {/* {this.state.accountStatus === "ChangePassword" ? ( */}
              <Formik
                initialValues={{ password: "", rePassword: "" }}
                validationSchema={this.validationSchemas}
                onSubmit={(values, actions) => {
                  this.goToConfirmationAfterPasswordChange(values);
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  handleBlur,
                  touched
                }) => (
                  <View>
                    <View
                      style={
                        Platform.OS === "web"
                          ? styles.passwordContainerWeb
                          : styles.bgPasswordContainer
                      }
                    >

{/*-------------------------- Password Field--------------------------------------------------- */}
                      <TextInput
                        testID={"txtInputPassword"}
                        style={
                          Platform.OS === "web"
                            ? styles.passwordInputWeb
                            : styles.bgPasswordInput
                        }
                        placeholder={this.placeholderIsPassword}
                        placeholderTextColor="#b2bac6"
                        onChangeText={handleChange("password")}
                        onBlur={() => handleBlur("password")}
                        secureTextEntry={
                          this.state.enablePasswordField ? true : false
                        }
                      />
                    </View>
                    <View>
                      {touched.password && errors.password ? (
                        <Text numberOfLines={2} style={styles.errorStyle2}>{errors.password}</Text>
                      ) : null}
                      <Text
                        style={
                          Platform.OS === "web" ? styles.passwordRulesStyle : {}
                        }
                      >
                        {this.state.passwordRules}
                      </Text>
                    </View>
                    
  {/* -------------------------------------Retype-Password field---------------------------------------------------- */}
                    
                    <View
                      style={
                        Platform.OS === "web"
                          ? styles.passwordContainerWeb
                          : styles.bgPasswordContainer
                      }
                    >
                      <TextInput
                        testID={"txtInputConfirmPassword"}
                        style={
                          Platform.OS === "web"
                            ? styles.passwordInputWeb
                            : styles.bgPasswordInput
                        }
                        placeholder={this.placeholderIsReTypePassword}
                        placeholderTextColor="#b2bac6"
                        onChangeText={handleChange("rePassword")}
                        onBlur={() => handleBlur("rePassword")}
                        secureTextEntry={
                          this.state.btnConfirmPasswordShowHide ? true : false
                        }
                      />
                    </View>
                    <View>
                      {touched.rePassword && errors.rePassword ? (
                        <Text style={styles.errorStyle}>
                          {errors.rePassword}
                        </Text>
                      ) : null}
                    </View>
                    {/* onPress={() => handleSubmit()} */}
    <TouchableOpacity disabled={this.state.loader}  onPress={() => handleSubmit()}>
              <View style={this.state.loader ? styles.unactive_button : styles.button}>
          <Text style={styles.buttonText}>Continue</Text>
          {this.state.loader ? <ActivityIndicator style={{position: 'absolute', right: 160}} size="large" color="#2e2442" /> : null }
      </View>
    </TouchableOpacity>
                  </View>
                )}
              </Formik>
            {/* ) : null} */}
        
          </View>
              {/* Customizable Area End */}
              </View>
            </View>
             </ImageBackground>
        </View>

    );
  }
}

// Customizable Area Start
const styles = StyleSheet.create({
   container: {
    flex: 1,
    flexDirection: 'column-reverse',
    backgroundColor: "#4e3e71",
  },
     desktopContainer: {
      flex: 1,
  },
  upperText: {
        fontSize: 32,
    textAlign: "left",
    color: "#4e3e71",
    paddingTop: 96,
    paddingBottom: 20
    },
    image: {
    flex: 1,
    justifyContent: "center"
  },
    desktopCard: {
    backgroundColor: '#e8fafe',
    margin: 'auto',
      borderRadius: 40,
    padding: 26
  },
  card: {
    position: 'relative',
    borderTopRightRadius: 24,
    backgroundColor: '#e8fafe',
    paddingHorizontal: 24
  },
  unactive_button: {
    borderRadius: 12,
    paddingVertical: 15,
    paddingHorizontal: 50,
    backgroundColor: '#8e7bb7',
    marginBottom: 38,
    marginTop: 100
  },
  button: {
    borderRadius: 12,
    paddingVertical: 15,
    paddingHorizontal: 50,
    backgroundColor: '#4e3e71',
    marginBottom: 38,
    marginTop: 100
  },
  desktopbutton: {
    borderRadius: 12,
    paddingVertical: 15,
    paddingHorizontal: 50,
    backgroundColor: '#4e3e71',
    marginBottom: 38,
    marginTop: 20
  },
  buttonText: {
    color: '#e8fafe',
    fontSize: 17,
    textAlign: 'center',
  },
  countryCodeSelector: {
    flex: 3,
    marginTop: 20,
    textAlign: "left",
    textAlignVertical: "center"
  },

  flexContainer: {
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    width: "100%"
  },

  headline: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    // textAlign: "center"
  },

  webInput: {
    marginTop: 20,
    width: "100%",
    zIndex: -1
  },

  inputAfterCountryCode: {
    width: "100%",
    zIndex: -1
  },

  mobileInput: {
    flexDirection: "row",
    fontSize: 16,
    textAlign: "left",
    backgroundColor: "#00000000",
    marginTop: 20,
    borderWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    includeFontPadding: true
  },

  codeInput: {
    marginTop: 20,
    width: "30%"
  },

  phoneInput: {
    flex: 3,
    marginTop: 20
  },

  noBorder: {
    borderBottomWidth: 0
  },

  titleText: {
    fontSize: 35,
    color: "rgb(0, 122, 242)",
    fontWeight: "bold",
    paddingBottom: 20,
    paddingTop: 20
  },

  stepText: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8,
    color: "#4e3e71",
    fontWeight: "bold",
  },

  emailText: {
    marginBottom: 16,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8,
    fontWeight: "bold"
  },

  bgRectBorder: {
    borderWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    marginTop: 20,
    minHeight: 40,
    fontSize: 18,
    textAlignVertical: "center",
    padding: 10
  },

  bgRectWeb: {
    marginTop: 40
  },

  errorStyle: {
    color: "red",
    textAlign: "left",
    paddingLeft: 10

  },
  errorStyle2: {
    color: "red",
    textAlign: "left",
    maxWidth: 420,
    paddingLeft: 10

  },

  passwordShowHide: {
    alignSelf: "center",
    backgroundColor: '#fff',
    marginRight: 20
  },

  passwordRulesStyle: {
    padding: 15
  },

  bgPasswordContainer: {
    flexDirection: "row",
    backgroundColor: "#00000000",
    marginTop: 2,
    borderWidth: 1,
    borderColor: "#767676",
   
    paddingLeft: 5,
    paddingRight: 5
  },
  bgPasswordInput: {
    flex: 1,
    fontSize: 16,
    textAlign: "left",
    backgroundColor: "#00000000",
    minHeight: 40,
    includeFontPadding: true
  },
  passwordContainerWeb: {
    // flex: 1,
    // flexDirection: "row",
    // marginVertical: 2,
    // borderRadius: 5,
    // paddingVertical: 10,
    // paddingLeft: 20,
    // backgroundColor: '#fff',
  },
  passwordInputWeb: {
    flex: 1,
    marginVertical: 5,
    paddingVertical: 10,
    paddingStart: 10,
    fontSize: 18,
    color: '#112950',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e5e5'
  },
  imgPasswordShowhide: Platform.OS === "web" ? { height: 30, width: 30, } : {}
});
// Customizable Area End
